'use strict';
define([], function () {
    var months = {JANUARY: 1, FEBRUARY: 2, MARCH: 3, APRIL: 4, MAY: 5, JUNE: 6, JULY: 7, AUGUST: 8, SEPTEMBER: 9, OCTOBER: 10, NOVEMBER: 11, DECEMBER: 12};
    return function (row) {
        var volumes = row.monthlySearchVolumes || [];
        var max = volumes.reduce(function (highest, volume) { return Math.max(highest, volume.searches || 0); }, 0);
        return volumes.map(function (volume) {
            var month = months[volume.month] || Number(volume.month) || 0;
            return {
                label: (month < 10 ? '0' + month : month) + '/' + String(volume.year || '').substring(2),
                searches: volume.searches,
                isPeak: max > 0 && volume.searches === max,
                height: max > 0 ? Math.max(Math.round((volume.searches / max) * 100), 4) : 4
            };
        });
    };
});
